//@import dependencies
import React, { useEffect, useMemo } from 'react'
// import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
//@end

// @import hooks
// @end

// @import services
import HomeService from 'app_services/user/homeService'
// @end

// @INFO Import Styles
import './../homeScreen.scss'
import { useSelector } from 'react-redux'
import { CombinedReducers } from 'app_events/index';
import InteractionService from 'app_services/interaction/interactionService'

// @ADD Component types
interface IHomeScreenLayoutProps {
  history: any
}

const HomeScreenLayout: React.FC<IHomeScreenLayoutProps> = (props) => {

  const homeService: HomeService = useMemo(() => new HomeService(), [])
  const app = useSelector((state: CombinedReducers) => state.app)
  const interactionService = useMemo(() => new InteractionService(), [])

  useEffect(() => {
    interactionService.checkCharacterizationSurveyAvailable()
  }, [])

  const HomeScreenLayout = useMemo(() => {
    return homeService.renderLayout({
      app,
      children: homeService.renderHome({}, props.history)
      // @ts-ignore
    }, AppContainer)
  }, [app, homeService, props.history])

  return HomeScreenLayout
}

export default HomeScreenLayout
